module.exports = __webpack_public_path__ + "static/media/YM02_1.ff112d34.jpg";